<template>
	<div class="SankeyChart">
		<div id="sankeychart" :style="{width: '550px', height: '180px'}"></div>
	</div>

</template>

<script>

	export default {
		name: "sankeychart",
		props: {
			data: Array,
			unit: String,
            flag:Boolean
		},
		data(){
			return {
				
			}
		},
        watch:{
            flag:function(newval,oldval){
                if(newval){
                    this.drawLine();
                }
            }
        },
		methods: {
            drawLine(){
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById('sankeychart'))
                var option;
                var data = {"nodes":[
                    // {"name":"Agricultural 'waste'"},
                    {name: 'Werne','itemStyle': {
                        'color': '#fdee00'
                    }},  
                    {name: 'Duesseldorf','itemStyle': {'color': '#01bc02'}}, 
                    {name: 'Cambridge','itemStyle': {'color': '#0b5033'}},
                    {name: 'Colma','itemStyle': {'color': '#02078d'}},  
                    { name: 'W. York','itemStyle': {'color': '#000ffd'}}, 
                    { name: ' am Main','itemStyle': {'color': '#00bf00'}},
                    {name: 'Metz','itemStyle': {'color': '#ff0603'}},
                    {name: 'Orleans','itemStyle': {'color': '#fc80d2'}},
                    // {name: 'c3'},
                    // {name: 'c4'},
                    {name: 'Saint-Denis','itemStyle': {'color': '#722e25'}},
                    {name: 'Hof','itemStyle': {'color': '#fb0568'}},
                    {name: 'Cliffside','itemStyle': {'color': '#3f0a7f'}},
                    {name: 'Leeds','itemStyle': {'color': '#015fae'}},
                    {name: 'Victoria'},
                    {name: 'Erlangen'},
                    {name: ' Germain en Laye'},
                    {name: ' Wokingham'},
                    {name: ' Runcorn'},
                    {name: 'dSix'},
                    {name: 'dSevent'},
                    {name: ' Newton'},
                    {name: ' Morangis'},
                    {name: ' Metchosin'},
                    {name: ' Kirkby'},
                    {name: ' London'},
                    {name: ' Offenbach'},
                    {name: ' Warrington'},
                    {name: ' Vancouver'},
                    {name: ' SuperiorCard'},
                    { name: 'bTwo','itemStyle': {'color': '#6c0765'}}, 
                    ],
                    "links":[
                         {source: 'Werne',target: 'W. York',value: 8}, 
                         {source: 'Duesseldorf',target: 'W. York',value: 8}, 
                         {source: 'Cambridge',target: 'bTwo',value: 2},
                         {source: 'Colma',target: ' am Main',value: 2},  
                         { source: 'W. York',target: 'Metz',value: 2}, 
                        //  { source: 'W. York',target: ' am Main',value: 1}, 
                        { source: 'W. York',target: 'Orleans',value: 2},
                        { source: 'W. York',target: 'dSix',value: 2},
                        { source: 'W. York',target: 'dSevent',value: 2},
                        { source: 'W. York',target: 'Saint-Denis',value: 2},
                        { source: 'W. York',target: 'Hof',value:2},
                        { source: 'W. York',target: 'Cliffside',value: 2},
                        { source: 'W. York',target: 'Leeds',value: 2},
                        // { source: 'b2',target: ' Warrington',value: 1},
                        { source: ' am Main',target: ' Vancouver',value: 1},
                        { source: ' am Main',target: ' SuperiorCard',value: 1},
                        { source: 'Metz',target: 'Victoria',value: 0.6},
                        { source: 'Metz',target: 'Erlangen',value: 0.6},
                        { source: 'Metz',target: ' Germain en Laye',value: 0.6},
                        { source: 'Orleans',target: ' Wokingham',value: 0.8},
                        { source: 'Orleans',target: ' Runcorn',value: 0.2},
                        { source: 'Saint-Denis',target: ' Newton',value: 0.5},
                        { source: 'Saint-Denis',target: ' Morangis',value: 0.5},
                        { source: 'Hof',target: ' Metchosin',value: 1},
                        { source: 'Cliffside',target: ' Kirkby',value: 0.2},
                        { source: 'Cliffside',target: ' London',value: 0.8},
                        { source: 'Leeds',target: ' Offenbach',value: 1},
                    ]}
               // 绘制图表
              
                myChart.hideLoading();

                myChart.setOption(option = {
                    // color: ['#ffec01','#01bf00','#095132','#010590','#000ffd','#6e046e','#04bf00','#ff0500','#f984b0'],
                    
                    // gradientColor:['#5470c6','#91cc75','#fac858','#ee6666','#73c0de','#3bDuesseldorf72','#fc8452','#9a60b4','#ea7ccc'],
                    title: {
                        text: null
                    },
                    tooltip: {
                        trigger: 'item',
                        triggerOn: 'mousemove'
                    },
                    animation: false,
                    series: [
                        {
                            type: 'sankey',
                            emphasis: {
                                focus: 'adjacency',
                                lineStyle:{
                                    opacity:0.5
                                }
                            },
                            // nodeAlign: 'right',
                            data: data.nodes,
                            links: data.links,
                            lineStyle: {
                                color:"gradient",
                                // color: {
                                //     type: 'linear',
                                //     x: 1,
                                //     y: 0,
                                //     x2: 0,
                                //     y2: 1,
                                //     colorStops: [{
                                //         offset: 0, color: 'red' // 0% 处的颜色
                                //     }, {
                                //         offset: 1, color: 'blue' // 100% 处的颜色
                                //     }],
                                //     globalCoord: false // 缺省为 false
                                // },
                                curveness: 0.5,
                                opaenergy: 0.8,
                                opacity:0.4
                            }
                        }
                    ]
                });
                option && myChart.setOption(option);
            }
		},
		mounted() {
			this.drawLine();
		}
	}
</script>

<style lang="less" scoped>
    .SankeyChart{
        width: 28vw;
        height: 20vh;
        background-color: rgba(255,255,255,.8);
        margin-left: 1vw;
        overflow: hidden;
        position: fixed;
        right: 2vw;
        top: 1.5vw;
        border-radius: 5px;
    }
</style>